/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import qs from 'qs'

/**
 * Braze custom event names
 */
export type BrazeCustomEventName = (typeof BrazeCustomEventName)[keyof typeof BrazeCustomEventName]

export const BrazeCustomEventName = {
  'quiz-email-submitted': 'quiz-email-submitted',
  'quiz-us-waitlist-email-submitted': 'quiz-us-waitlist-email-submitted',
  'quiz-gb-waitlist-email-submitted': 'quiz-gb-waitlist-email-submitted',
  'waitlist-email-submitted': 'waitlist-email-submitted',
  'nutrition-newsletter-email-submitted': 'nutrition-newsletter-email-submitted',
  'email-capture-cms-email-submitted': 'email-capture-cms-email-submitted',
  'freeguide-email-submitted': 'freeguide-email-submitted',
  'gutshot-email-submitted': 'gutshot-email-submitted',
  'whitepaper-email-submitted': 'whitepaper-email-submitted',
  'box-preparation-requested': 'box-preparation-requested',
  'box-dispatched': 'box-dispatched',
  'box-scanned': 'box-scanned',
  'start-date-selected': 'start-date-selected',
  'd30-gb-no-stock-waitlist-email-submitted': 'd30-gb-no-stock-waitlist-email-submitted',
  'd30-us-no-stock-waitlist-email-submitted': 'd30-us-no-stock-waitlist-email-submitted',
  'd30-non-purchase-country-waitlist-email-submitted': 'd30-non-purchase-country-waitlist-email-submitted',
  'd30-checkout-email-entered': 'd30-checkout-email-entered',
  'd30-checkout-address-confirmed': 'd30-checkout-address-confirmed',
  'zoe-classic-gb-waitlist-email-submitted': 'zoe-classic-gb-waitlist-email-submitted',
  'zoe-classic-us-waitlist-email-submitted': 'zoe-classic-us-waitlist-email-submitted',
  'zoe-classic-non-purchase-country-waitlist-email-submitted':
    'zoe-classic-non-purchase-country-waitlist-email-submitted',
  'zoe-plus-free-trial-started': 'zoe-plus-free-trial-started',
  'zoe-plus-free-trial-cancelled': 'zoe-plus-free-trial-cancelled',
  'zoe-plus-trial-ending': 'zoe-plus-trial-ending',
  'daily-reward-summary-submitted': 'daily-reward-summary-submitted',
  'checkout-start': 'checkout-start',
  'fulfilment-delivered': 'fulfilment-delivered',
  'sample-scanned': 'sample-scanned',
  'sample-mailed': 'sample-mailed',
  'custom-attribute-sent': 'custom-attribute-sent',
  'user-account-action': 'user-account-action',
  'referee-signup': 'referee-signup',
  'referee-discount-redeemed': 'referee-discount-redeemed',
  'referrer-reward-redeemed': 'referrer-reward-redeemed',
  'd30-non-gb-waitlist-email-submitted': 'd30-non-gb-waitlist-email-submitted',
  'user-results-onboarding-ended': 'user-results-onboarding-ended',
  'menoscale-email-submitted': 'menoscale-email-submitted',
  'quantity-change': 'quantity-change',
} as const

/**
 * @nullable
 */
export type TrackUserRequestCustomEventProperties = { [key: string]: unknown } | null

/**
 * @nullable
 */
export type TrackUserRequestAdditionalFields = { [key: string]: unknown } | null

export interface TrackUserRequest {
  /** @nullable */
  externalId?: string | null
  email: string
  customEventName: BrazeCustomEventName
  /** @nullable */
  customEventProperties?: TrackUserRequestCustomEventProperties
  /** @nullable */
  marketingConsent?: boolean | null
  /** @nullable */
  additionalFields?: TrackUserRequestAdditionalFields
}

export interface TrackUserResponse {
  email: string
}

/**
 * @nullable
 */
export type TrackPurchaseRequestProperties = { [key: string]: unknown } | null

export interface TrackPurchaseRequest {
  email: string
  /** @nullable */
  quizUserId?: string | null
  firstName: string
  lastName: string
  orderNumber: string
  orderCountry: string
  /** @nullable */
  plansSlug?: string | null
  preorder: boolean
  freeTrial: boolean
  productId: string
  /** @nullable */
  currency?: string | null
  /** @minimum 0 */
  price: number
  /** @minimum 1 */
  quantity: number
  time: string
  /** @nullable */
  properties?: TrackPurchaseRequestProperties
}

export interface TrackPurchaseResponse {
  email: string
}

/**
 * Optimizely experiment assignments active for this lead (experimentName -> variation)
 * @nullable
 */
export type RecordPurchaseRequestExperiments = { [key: string]: string } | null

export interface RecordPurchaseRequest {
  /**
   * The opaque attribution lead_id the purchase is recorded against
   * @minLength 0
   * @maxLength 255
   */
  leadId: string
  /**
   * Comma-separated product types purchased
   * @minLength 1
   */
  product: string
  /**
   * What the customer paid: order total after discounts, incl. tax and shipping
   * @minimum 0
   */
  value: number
  /**
   * Uppercase ISO-4217 currency code of the purchase (lowercase is rejected)
   * @nullable
   */
  currency?: string | null
  /**
   * Optimizely experiment assignments active for this lead (experimentName -> variation)
   * @nullable
   */
  experiments?: RecordPurchaseRequestExperiments
}

export interface RecordPurchaseResponse {
  leadId: string
}

/**
 * Optimizely experiment assignments active for this lead (experimentName -> variation)
 * @nullable
 */
export type RecordLeadCapturedRequestExperiments = { [key: string]: string } | null

export interface RecordLeadCapturedRequest {
  /**
   * The opaque attribution lead_id the capture is recorded against
   * @minLength 0
   * @maxLength 255
   */
  leadId: string
  /**
   * Optimizely experiment assignments active for this lead (experimentName -> variation)
   * @nullable
   */
  experiments?: RecordLeadCapturedRequestExperiments
}

export interface RecordLeadCapturedResponse {
  leadId: string
  leadCaptured: boolean
}

export interface RecordLandingRequest {
  /**
   * The opaque lead_id the landing is stored against (minted client-side at landing).
   * @minLength 0
   * @maxLength 255
   */
  leadId: string
  /**
   * The landing page query string (UTMs and click-ids).
   * @minLength 0
   * @maxLength 2048
   */
  urlParameters: string
  /**
   * The referrer URL of the landing.
   * @minLength 0
   * @maxLength 2048
   * @nullable
   */
  referrer?: string | null
}

export interface RecordLandingResponse {
  /** The opaque lead_id the landing was recorded against. */
  leadId: string
}

export interface ReconcileEmailAliasRequest {
  username: string
}

export type ReconcileEmailAliasResponseOutcome =
  (typeof ReconcileEmailAliasResponseOutcome)[keyof typeof ReconcileEmailAliasResponseOutcome]

export const ReconcileEmailAliasResponseOutcome = {
  UP_TO_DATE: 'UP_TO_DATE',
  ADDED: 'ADDED',
  RENAMED: 'RENAMED',
  WRITE_FAILED: 'WRITE_FAILED',
} as const

export interface ReconcileEmailAliasResponse {
  username: string
  outcome: ReconcileEmailAliasResponseOutcome
}

export interface GetUserResponse {
  /** @nullable */
  externalId?: string | null
  /** @nullable */
  email?: string | null
  /** @nullable */
  firstName?: string | null
  /** @nullable */
  lastName?: string | null
}

export type TransactionalEmailType = (typeof TransactionalEmailType)[keyof typeof TransactionalEmailType]

export const TransactionalEmailType = {
  ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
  BARS_ORDER_CONFIRMATION: 'BARS_ORDER_CONFIRMATION',
  BARS_ACCOUNT_COMPLETION: 'BARS_ACCOUNT_COMPLETION',
  BARS_RENEWAL_UPCOMING: 'BARS_RENEWAL_UPCOMING',
  BARS_FULLY_CANCELLED: 'BARS_FULLY_CANCELLED',
  BARS_CHANGE_SUBSCRIPTION: 'BARS_CHANGE_SUBSCRIPTION',
  D30_ORDER_CONFIRMATION: 'D30_ORDER_CONFIRMATION',
  D30_ACCOUNT_COMPLETION: 'D30_ACCOUNT_COMPLETION',
  D30_RENEWAL_UPCOMING: 'D30_RENEWAL_UPCOMING',
  D30_FULLY_CANCELLED: 'D30_FULLY_CANCELLED',
  D30_RESTART_SUBSCRIPTION: 'D30_RESTART_SUBSCRIPTION',
  ZOE_PLUS_RENEWAL_UPCOMING: 'ZOE_PLUS_RENEWAL_UPCOMING',
  ZOE_PLUS_AUTORENEWAL_CANCELLED: 'ZOE_PLUS_AUTORENEWAL_CANCELLED',
  ZOE_PLUS_FULLY_CANCELLED: 'ZOE_PLUS_FULLY_CANCELLED',
  ZOE_PLUS_TRIAL_ENDING: 'ZOE_PLUS_TRIAL_ENDING',
  ZOE_MEMBERSHIP_ACCOUNT_COMPLETION: 'ZOE_MEMBERSHIP_ACCOUNT_COMPLETION',
  ZOE_MEMBERSHIP_ORDER_CONFIRMATION_GB: 'ZOE_MEMBERSHIP_ORDER_CONFIRMATION_GB',
  ZOE_MEMBERSHIP_ORDER_CONFIRMATION_US: 'ZOE_MEMBERSHIP_ORDER_CONFIRMATION_US',
  ZOE_MEMBERSHIP_SWITCHING_TO_WW: 'ZOE_MEMBERSHIP_SWITCHING_TO_WW',
  ZOE_MEMBERSHIP_SWITCHING_TO_999: 'ZOE_MEMBERSHIP_SWITCHING_TO_999',
  ZOE_MEMBERSHIP_RENEWAL_UPCOMING: 'ZOE_MEMBERSHIP_RENEWAL_UPCOMING',
  ZOE_MEMBERSHIP_AUTORENEWAL_CANCELLED: 'ZOE_MEMBERSHIP_AUTORENEWAL_CANCELLED',
  ZOE_MEMBERSHIP_UNDO_AUTORENEWAL_CANCELLED: 'ZOE_MEMBERSHIP_UNDO_AUTORENEWAL_CANCELLED',
  ZOE_MEMBERSHIP_FULLY_CANCELLED: 'ZOE_MEMBERSHIP_FULLY_CANCELLED',
  METABOLIC_RESULTS_EMAIL: 'METABOLIC_RESULTS_EMAIL',
  MICROBIOME_RESULTS_EMAIL: 'MICROBIOME_RESULTS_EMAIL',
  GDPR_DSAR_RELEASE_EMAIL: 'GDPR_DSAR_RELEASE_EMAIL',
  CHECKOUT_COMPLETE_ACCOUNT_COMPLETION: 'CHECKOUT_COMPLETE_ACCOUNT_COMPLETION',
  CHECKOUT_COMPLETE_ORDER_CONFIRMATION: 'CHECKOUT_COMPLETE_ORDER_CONFIRMATION',
  MIGRATION_FROM_CLASSIC_TO_FREEMIUM_COMPLETED: 'MIGRATION_FROM_CLASSIC_TO_FREEMIUM_COMPLETED',
  MICROBIOME_KIT_ARRIVED: 'MICROBIOME_KIT_ARRIVED',
  MICROBIOME_RESULTS_AVAILABLE: 'MICROBIOME_RESULTS_AVAILABLE',
  SUBSCRIPTION_SWITCH_SCHEDULED: 'SUBSCRIPTION_SWITCH_SCHEDULED',
  SUBSCRIPTION_SWITCH_SCHEDULED_D30: 'SUBSCRIPTION_SWITCH_SCHEDULED_D30',
  SUBSCRIPTION_SWITCH_SCHEDULED_ZOE_PLUS: 'SUBSCRIPTION_SWITCH_SCHEDULED_ZOE_PLUS',
  REFERRAL_REFEREE_DISCOUNT_EMAIL: 'REFERRAL_REFEREE_DISCOUNT_EMAIL',
  REFERRAL_REFERRER_REWARD_EMAIL: 'REFERRAL_REFERRER_REWARD_EMAIL',
  REFERRAL_REFERRER_REWARD_AUTO_APPLIED_EMAIL: 'REFERRAL_REFERRER_REWARD_AUTO_APPLIED_EMAIL',
  REFERRAL_TEST_REFERRER_REWARD_D30_FREE_MONTH_AUTO_APPLIED_EMAIL:
    'REFERRAL_TEST_REFERRER_REWARD_D30_FREE_MONTH_AUTO_APPLIED_EMAIL',
  REFERRAL_TEST_REFERRER_REWARD_D30_FREE_MONTH_MANUAL_APPLY_EMAIL:
    'REFERRAL_TEST_REFERRER_REWARD_D30_FREE_MONTH_MANUAL_APPLY_EMAIL',
  MEAL_ADVICE_EMAIL: 'MEAL_ADVICE_EMAIL',
  MEAL_ADVICE_GENERIC_EMAIL: 'MEAL_ADVICE_GENERIC_EMAIL',
} as const

export type LookupBrazeUserParams = {
  username?: string
  email?: string
}

export const getCrmServiceClient = (axiosInstance: AxiosInstance = axios) => {
  /**
   * @summary Track a new or existing user with an email.
   */
  const trackUser = (
    trackUserRequest: TrackUserRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<TrackUserResponse>> => {
    return axiosInstance.post(`/public/users/track`, trackUserRequest, options)
  }

  /**
   * @summary Track a purchase event made by a new or existing user.
   */
  const trackPurchase = (
    trackPurchaseRequest: TrackPurchaseRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<TrackPurchaseResponse>> => {
    return axiosInstance.post(`/public/users/track-purchase`, trackPurchaseRequest, options)
  }

  /**
   * @summary Record a purchase (product and value) against the attribution row for a lead_id.
   */
  const recordPurchase = (
    recordPurchaseRequest: RecordPurchaseRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<RecordPurchaseResponse>> => {
    return axiosInstance.post(`/public/attribution/purchases`, recordPurchaseRequest, options)
  }

  /**
   * @summary Flag the attribution row for a lead_id as captured. No email is stored.
   */
  const recordLeadCaptured = (
    recordLeadCapturedRequest: RecordLeadCapturedRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<RecordLeadCapturedResponse>> => {
    return axiosInstance.post(`/public/attribution/lead-captured`, recordLeadCapturedRequest, options)
  }

  /**
   * @summary Record an attributed landing and return the opaque lead_id it is stored against.
   */
  const recordLanding = (
    recordLandingRequest: RecordLandingRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<RecordLandingResponse>> => {
    return axiosInstance.post(`/public/attribution/landings`, recordLandingRequest, options)
  }

  /**
   * Looks up the member's current email in member-directory and ensures their Braze `email` alias matches it (adds it if missing, renames it via /users/alias/update if drifted, no-ops if already correct). Returns 404 if the user is not found in member-directory or has no Braze profile.
   * @summary Reconcile a user's Braze email alias against their current email in member-directory.
   */
  const reconcileEmailAlias = (
    reconcileEmailAliasRequest: ReconcileEmailAliasRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ReconcileEmailAliasResponse>> => {
    return axiosInstance.post(`/private/users/reconcile-email-alias`, reconcileEmailAliasRequest, options)
  }

  /**
   * Calls the same as the transactional email send flow: if `email` is present, the email alias is tried first; on a miss, falls back to the external_id lookup and reconciles the alias as a side effect so future alias lookups succeed — but only when member-directory confirms the username still owns that email (guards deleted/erased users). If only `username` is present, the external_id is queried directly. At least one of `username` or `email` is required. Returns 404 if no Braze profile can be resolved.
   * @summary Look up a user in Braze by username, email, or both.
   */
  const lookupBrazeUser = (
    params?: LookupBrazeUserParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetUserResponse>> => {
    return axiosInstance.get(`/private/users/lookup`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get all the transactional email types available for the user. Will expose the enum for other service to use.
   */
  const getEmailTypes = (options?: AxiosRequestConfig): Promise<AxiosResponse<TransactionalEmailType[]>> => {
    return axiosInstance.get(`/private/email-types`, options)
  }

  /**
   * @summary Get all the braze custom event names available. Will expose the enum for other service to use.
   */
  const getBrazeCustomEventNames = (options?: AxiosRequestConfig): Promise<AxiosResponse<BrazeCustomEventName[]>> => {
    return axiosInstance.get(`/private/custom-event-names`, options)
  }

  return {
    trackUser,
    trackPurchase,
    recordPurchase,
    recordLeadCaptured,
    recordLanding,
    reconcileEmailAlias,
    lookupBrazeUser,
    getEmailTypes,
    getBrazeCustomEventNames,
  }
}
export type TrackUserResult = AxiosResponse<TrackUserResponse>
export type TrackPurchaseResult = AxiosResponse<TrackPurchaseResponse>
export type RecordPurchaseResult = AxiosResponse<RecordPurchaseResponse>
export type RecordLeadCapturedResult = AxiosResponse<RecordLeadCapturedResponse>
export type RecordLandingResult = AxiosResponse<RecordLandingResponse>
export type ReconcileEmailAliasResult = AxiosResponse<ReconcileEmailAliasResponse>
export type LookupBrazeUserResult = AxiosResponse<GetUserResponse>
export type GetEmailTypesResult = AxiosResponse<TransactionalEmailType[]>
export type GetBrazeCustomEventNamesResult = AxiosResponse<BrazeCustomEventName[]>
